let themeVariant =
	document.cookie
		.split('; ')
		.find((row) => row.startsWith('occasions_theme='))
		?.split('=')[1] || 'dark';

const mobileMenuButton = document.querySelector(
	'.site-menu__mobile-toggle-button'
);

const themeSwitchButton = document.querySelector('.site-menu__toggle-button');

/**
 * Toggle dark/light theme
 */
const toggleTheme = () => {
	themeVariant = themeVariant === 'dark' ? 'light' : 'dark';
	document.documentElement.classList.toggle(
		'site--light-theme',
		themeVariant === 'light'
	);
	document.cookie = `occasions_theme=${themeVariant}; path=/`;
};

const updateThemeToggleButton = () => {
	const [darkLabel, lightLabel] = themeSwitchButton.children;
	const isOn = themeVariant === 'light';
	darkLabel.classList.toggle('site-menu__toggle-button-label--active', !isOn);
	lightLabel.classList.toggle('site-menu__toggle-button-label--active', isOn);
	themeSwitchButton.ariaChecked = isOn;
};

/**
 * Set up menu ARIA
 */
const setupMenuAria = () => {
	const menuEl = document.querySelector('.site-menu__nav').firstElementChild;
	const siteHeaderEl = document.querySelector('.site-header');
	menuEl.querySelectorAll('.menu-item-has-children').forEach((branchItemEl) => {
		const subMenuEl = document.querySelector('.sub-menu');
		const itemId = Array.from(branchItemEl.classList.values()).find(
			(className) => /^menu-item-\d+$/.test(className)
		);
		branchItemEl.id = itemId;
		subMenuEl.id = `${itemId}-submenu`;
		subMenuEl.ariaHidden = 'true';
		branchItemEl.setAttribute('aria-controls', subMenuEl.id);
		branchItemEl.addEventListener('mouseenter', () => {
			branchItemEl.ariaExpanded = 'true';
			subMenuEl.ariaHidden = 'false';
			siteHeaderEl.style.setProperty(
				'--h-menu-extra',
				`calc(${branchItemEl.querySelector('.sub-menu').offsetHeight}px + 2rem)`
			);
		});
		branchItemEl.addEventListener('mouseleave', () => {
			branchItemEl.ariaExpanded = 'false';
			subMenuEl.ariaHidden = 'true';
			siteHeaderEl.style.setProperty('--h-menu-extra', '0px');
		});
	});
};

/**
 * Toggle mobile menu
 */
const toggleMobileMainMenu = () => {
	const container = document.querySelector('.site-menu__container');
	mobileMenuButton.classList.toggle('site-menu__mobile-toggle-button--cross');
	container.classList.toggle('site-menu__container--mobile-visible');
};

/**
 * Set up main menu.
 */
const mainMenu = () => {
	setupMenuAria();
	if (themeSwitchButton) {
		themeSwitchButton.addEventListener('click', () => {
			toggleTheme();
			updateThemeToggleButton();
		});
	}
	if (mobileMenuButton) {
		mobileMenuButton.addEventListener('click', () => {
			toggleMobileMainMenu();
		});
	}
};

// run it!
mainMenu();
updateThemeToggleButton();
